<div class="lm-facade-detail-wrapper">
<div class="lm-facade-detail-title">
  <h3 class="lm-bold lm-header-3">{{propertiesLabel}}</h3>
<!--  @if(displayTemplateDetail().reportType) {-->
<!--    @switch (displayTemplateDetail().reportType) {-->
<!--      @case ('transactional') {-->
<!--        <svg soho-icon [icon]="'unorderedlist'" soho-tooltip [content]="transactionalLabel"/>-->
<!--      }@case ('columnar') {-->
<!--        <svg soho-icon [icon]="'database'" soho-tooltip [content]="columnarLabel"/>-->
<!--      }-->
<!--      @case ('cube') {-->
<!--        <svg soho-icon [icon]="'line-chart'" soho-tooltip [content]="cubeLabel"/>-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--  @if (displayTemplateDetail().archiveData) {-->
<!--    <svg soho-icon [icon]="'archives'" soho-tooltip [content]="archiveLabel"/>-->
<!--  }-->
<!--  @if (displayTemplateDetail().asOfDateData) {-->
<!--    <svg soho-icon [icon]="'calendar'" soho-tooltip [content]="'As of ' + asOfDateLabel()"/>-->
<!--  }-->
<!--  @if (displayTemplateDetail().auditData) {-->
<!--    <svg soho-icon [icon]="'search-folder'" soho-tooltip [content]="auditLabel"/>-->
<!--  }-->
</div>
<div class="lm-facade-detail-content" [class.lm-facade-detail-loaded]="reportTemplateDetail">
  <soho-accordion [allowOnePane]="true" [expanderDisplay]="'chevron'">
    @if (showFields()) {
      <soho-accordion-header id="fields">
        <a href="#">
          <span>{{fieldsLabel}}</span>
        </a>
      </soho-accordion-header>
      <soho-accordion-pane [ngClass]="heightClass()">
        <lm-report-facade-report-template-panel
          [fields]="displayTemplateDetail().fields"
        ></lm-report-facade-report-template-panel>
      </soho-accordion-pane>
    }
    @if (showDimensions()) {
      <soho-accordion-header id="dimensions">
        <a href="#">
          <span>{{dimensionsLabel}}</span>
        </a>
      </soho-accordion-header>
      <soho-accordion-pane [ngClass]="heightClass()">
        <lm-report-facade-report-template-panel
          [fields]="displayTemplateDetail().dimensions"
        ></lm-report-facade-report-template-panel>
      </soho-accordion-pane>
    }
    @if (showMeasures()) {
      <soho-accordion-header id="measures">
        <a href="#">
          <span>{{measuresLabel}}</span>
        </a>
      </soho-accordion-header>
      <soho-accordion-pane [ngClass]="heightClass()">
        <lm-report-facade-report-template-panel
          [fields]="displayTemplateDetail().measures"
        ></lm-report-facade-report-template-panel>
      </soho-accordion-pane>
    }
    @if (showFilter()) {
      <soho-accordion-header id="filter">
        <a href="#">
          <span>{{filterLabel}}</span>
        </a>
      </soho-accordion-header>
      <soho-accordion-pane [ngClass]="heightClass()">
        <lm-report-facade-report-template-panel
          [label]="filterLabel"
          [listFilter]="displayTemplateDetail().listFilter"
          [reportFilter]="displayTemplateDetail().reportFilter"
        ></lm-report-facade-report-template-panel>
      </soho-accordion-pane>
    }
    @if (showSort()) {
      <soho-accordion-header id="sort">
        <a href="#">
          <span>{{sortLabel}}</span>
        </a>
      </soho-accordion-header>
      <soho-accordion-pane [ngClass]="heightClass()">
        <lm-report-facade-report-template-panel
          [sortBy]="displayTemplateDetail().sortBy"
        ></lm-report-facade-report-template-panel>
      </soho-accordion-pane>
    }
  </soho-accordion>
</div>
<div class="lm-facade-detail-footer">
    <button soho-button="primary" (click)="onStartReportClicked()">{{startReportLabel}}</button>
</div>
</div>
